import { Icon } from '@chakra-ui/react';
import React from 'react';

const CustomIcon: React.FC<{ isChecked: boolean }> = ({ isChecked }) => {
  const d =
    'M0 2.5C0 1.39543 0.895431 0.5 2 0.5H13C14.1046 0.5 15 1.39543 15 2.5V13.5C15 14.6046 14.1046 15.5 13 15.5H2C0.895431 15.5 0 14.6046 0 13.5V2.5Z';
  return (
    <>
      {isChecked ? (
        <Icon viewBox='0 0 14 14'>
          <path fill='#1CA5CC' d={d} />
        </Icon>
      ) : null}
    </>
  );
};
export default CustomIcon;
